"use client";

import { c as _c } from "react/compiler-runtime";
import { clsx } from "@/helpers/clsx";
import Simplex from "@/helpers/simplex";
import { useInView } from "framer-motion";
import React from "react";
import { FeatureContainer } from "./BentoBoxComponents";
export const FundraisingPlanner = t0 => {
  const $ = _c(23);
  const {
    children,
    columns,
    fundraises,
    logos
  } = t0;
  const scrollRef = React.useRef(null);
  const itemsRef = React.useRef(null);
  const [animationEnabled, setAnimationEnabled] = React.useState(false);
  const isInView = useInView(scrollRef);
  let t1;
  let t2;
  if ($[0] !== isInView) {
    t1 = () => {
      const animationEnabled_0 = isInView;
      setAnimationEnabled(animationEnabled_0);
      if (!animationEnabled_0) {
        return;
      }
      const el = scrollRef.current as HTMLElement;
      if (!el) {
        return;
      }
      const interval = setInterval(() => {
        const scrollLeft = el.scrollLeft;
        const scrollTo = scrollLeft === 0 ? el.scrollWidth : 0;
        el.scrollTo({
          left: scrollTo,
          behavior: "smooth"
        });
      }, 5000);
      return () => clearInterval(interval);
    };
    t2 = [isInView];
    $[0] = isInView;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  React.useEffect(t1, t2);
  let t3;
  let t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = clsx("feature-fundraise !px-0 !pb-0 sm:col-span-2");
    t4 = () => {
      setAnimationEnabled(false);
    };
    t5 = () => {
      setAnimationEnabled(true);
    };
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] !== animationEnabled) {
    t6 = animationEnabled && <FakeCursor itemsRef={itemsRef} />;
    $[6] = animationEnabled;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== columns) {
    t7 = columns.map(_temp);
    $[8] = columns;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== fundraises || $[11] !== isInView || $[12] !== logos) {
    t8 = isInView && fundraises.map((fundraise, i_0) => <div className="bg-btn-secondary group/item relative select-none whitespace-nowrap rounded-lg border border-black/20 p-2 opacity-60 shadow-md shadow-black/30 transition-all duration-200 ease-in-out hover:scale-[105%] hover:opacity-100 active:scale-100 active:opacity-100 active:transition-none [&.hover]:scale-[105%] [&.hover]:opacity-100" key={i_0} draggable="true" onDragStart={_temp2} onDragEnd={_temp3}><div className="flex items-center gap-x-2"><div className="ml-1 inline-flex items-center justify-center rounded-md bg-white/10 p-1 shadow-sm shadow-black/30" style={{
          background: logos[i_0]?.color
        }}><svg className={clsx("size-3.5 transform-gpu brightness-0 invert", logos[i_0]?.className)}><use href={`/_static/sprites/logos.svg#${logos[i_0]?.id}`} aria-label={`${logos[i_0]?.id} logo`} /></svg></div><div className="text-xs font-semibold capitalize text-neutral-100">{logos[i_0]?.id}</div></div><div className="mt-1.5 flex flex-col text-center"><div className="flex items-center gap-x-1"><div className="ml-0.5 flex flex-1 items-center gap-x-2 rounded-md px-2 py-1 text-xs"><div className={clsx("size-3 rounded-[4px] border border-white/5 text-xs", fundraise.background, "bg-opacity-20")} />{fundraise.name}{" "}<span className="text-body/50">–</span> ${fundraise.amount}m</div></div><div className="mt-1 rounded-md border border-neutral-700/30 bg-neutral-900/20 px-2 py-0.5 text-xs opacity-20 shadow-sm shadow-black/30">Pro-rata ${fundraise.prorata}m</div></div></div>);
    $[10] = fundraises;
    $[11] = isInView;
    $[12] = logos;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t7 || $[15] !== t8) {
    t9 = <div className="fade-bottom scrollbar-hidden absolute inset-x-0 bottom-0 top-8 scroll-px-4 overflow-x-auto overflow-y-hidden [--mask-size:90%]" ref={scrollRef}><div className="grid-pr grid animate-fadeIn grid-cols-[repeat(4,250px)] gap-x-4 gap-y-2 px-4" ref={itemsRef}>{t7}{t8}</div></div>;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t6 || $[18] !== t9) {
    t10 = <div className="relative flex-1 select-none">{t6}{t9}</div>;
    $[17] = t6;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== children || $[21] !== t10) {
    t11 = <FeatureContainer className={t3} onMouseEnter={t4} onMouseLeave={t5}>{children}{t10}</FeatureContainer>;
    $[20] = children;
    $[21] = t10;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  return t11;
};
const FakeCursor = t0 => {
  const $ = _c(4);
  const {
    itemsRef
  } = t0;
  const cursorRef = React.useRef(null);
  let t1;
  let t2;
  if ($[0] !== itemsRef) {
    t1 = () => {
      if (!cursorRef.current) {
        return;
      }
      const simplex = new Simplex();
      const canAnimateHover = "requestIdleCallback" in window;
      let startA;
      let lastTime = 0;
      const parent = cursorRef.current.parentElement as HTMLElement;
      if (!parent) {
        return;
      }
      const offsetWidth = parent.offsetWidth;
      const offsetHeight = parent.offsetHeight;
      const render = a => {
        if (!cursorRef.current) {
          return;
        }
        if (!startA) {
          startA = a;
        }
        if (a - lastTime < 8.333333333333334) {
          requestAnimationFrame(render);
          return;
        }
        lastTime = a;
        const speed = (a - startA) * 0.00015;
        const noiseX = simplex.noise(0, speed) / 2;
        const noiseY = simplex.noise(1, speed) / 2;
        const x = noiseX * offsetWidth;
        const y = noiseY * offsetHeight;
        cursorRef.current.style.transform = `translate3d(${x}px, ${y}px, 0px)`;
        const items = (itemsRef.current as HTMLElement)?.children;
        if (items && canAnimateHover) {
          requestIdleCallback(() => {
            if (!cursorRef.current) {
              return;
            }
            const cRect = cursorRef.current.getBoundingClientRect();
            const cx = cRect.left;
            const cy = cRect.top;
            for (const item of Array.from(items)) {
              const rect = item.getBoundingClientRect();
              if (cx >= rect.left && cx <= rect.right && cy >= rect.top && cy <= rect.bottom) {
                item.classList.add("hover");
              } else {
                item.classList.remove("hover");
              }
            }
          });
        }
        requestAnimationFrame(render);
      };
      const frame = requestAnimationFrame(render);
      const children = (itemsRef.current as HTMLElement)?.children;
      return () => {
        cancelAnimationFrame(frame);
        if (children) {
          for (const item_0 of Array.from(children)) {
            (item_0 as HTMLElement).classList.remove("hover");
          }
        }
      };
    };
    t2 = [itemsRef];
    $[0] = itemsRef;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  React.useEffect(t1, t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="pointer-events-none absolute inset-0 top-16 z-50 flex items-center justify-center"><img src="/_static/images/cursor.static.svg" className="h-6 w-6 transform-gpu will-change-transform" ref={cursorRef} alt="cursor" /></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
function _temp(c, i) {
  return <div className={clsx("sticky top-0 z-10 bg-[#111111] text-center text-xs font-bold text-neutral-400")} key={c}>{c}</div>;
}
function _temp2(e) {
  const target = e.currentTarget;
  target.classList.add("cursor-grabbing", "!scale-100");
  setTimeout(() => {
    target.classList.add("!opacity-20");
  }, 0);
}
function _temp3(e_0) {
  e_0.currentTarget.classList.remove("!opacity-20", "cursor-grabbing", "!scale-100");
}